import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { Stack } from "@mui/material";
import { useCustomModel } from "components/context/CustomProvider";
import { useNiceModalLocker } from "components/context/NiceModalProvider";
import CustomDialog from "components/ui/customs/CustomDialog";
import CustomModelProvider from "components/ui/customs/CustomModelProvider";
import CustomForm, {
  CustomFormActions,
  CustomFormDataWatcher,
  CustomFormErrors,
  CustomFormFields,
  CustomFormTitle,
} from "components/ui/customs/forms/CustomForm";
import useCustomDataSource from "components/ui/customs/useCustomDataSource";
import { CaptableMultiFundWidget } from "models/backoffice/modelComponents/CaptableWidget";

const CaptableUpdateModal = (modelName) => {
  if (!modelName || modelName !== "reporting.CaptableLight") {
    throw new Error(
      "CaptableUpdateModal requires a modelName to be 'reporting.CaptableLight'",
    );
  }

  return NiceModal.create(({ id }) => {
    const modal = useModal();
    const model = useCustomModel(modelName);
    const dataSource = useCustomDataSource(modelName);
    const { locked, setLocked, closeFormIfNotLocked, forceClose } =
      useNiceModalLocker(modal);

    return (
      <CustomModelProvider modelName={modelName} id={id}>
        {(data, reftech) => (
          <CustomDialog
            variant="dialog"
            open={modal.visible}
            onClose={closeFormIfNotLocked}
          >
            <CustomForm
              title={`Update ${model.modelName}${locked ? " (Locked)" : ""}`}
              defaultValues={data}
              fields={model.fields}
              submitter={dataSource.updateOne}
              deleter={dataSource.deleteOne}
              onDone={modal.hide}
              onDeleted={modal.hide}
              onCancel={forceClose}
              onIsDirty={setLocked}
              modelName={modelName}
            >
              <CustomDialog title>
                <CustomFormTitle />
              </CustomDialog>
              <CustomDialog content>
                <Stack spacing={2}>
                  <CustomFormDataWatcher>
                    {(formData) => (
                      <CaptableMultiFundWidget captable={formData} />
                    )}
                  </CustomFormDataWatcher>
                  <CustomFormErrors />
                  <CustomFormFields />
                </Stack>
              </CustomDialog>
              <CustomDialog actions>
                <CustomFormActions />
              </CustomDialog>
            </CustomForm>
          </CustomDialog>
        )}
      </CustomModelProvider>
    );
  });
};

export default CaptableUpdateModal;
